// extracted by mini-css-extract-plugin
export default {"chat":"Chat-module__chat--c8813"};